import {
  maxLength,
  required,
  TextInput,
  useDataProvider,
  useTranslate,
} from "react-admin";
import { useWatch, useFormContext } from "react-hook-form";
import Grid from "@mui/material/Grid";
import { useEffect, useRef } from "react";
import { useMutation } from "react-query";

const validateCode = [required(), maxLength(100)];
const validateName = [required(), maxLength(125)];

export default function DisabledInput({
  dependOn,
  resetFields,
  codeDoesNotExist,
}) {
  const { setValue, getValues } = useFormContext();
  const dataProvider = useDataProvider();
  const dependOnKind = useWatch({ name: dependOn });
  const t = useTranslate();
  const isFirstRender = useRef(dependOnKind);

  const { data, mutate, isLoading } = useMutation((prm) => {
    return dataProvider.getListNoParams("kinds/" + prm);
  });
  useEffect(() => {
    if (dependOnKind) {
      mutate(encodeURIComponent(dependOnKind));
    }
    if (isFirstRender.current === dependOnKind) {
      return;
    }
    isFirstRender.current = dependOnKind;
    setValue("code", "");
    setValue("name", "");
    setValue("brand_name", "");
    setValue("size_name", "");
    setValue("motif_name", "");
    setValue("density_name", "");
    setValue("color_name", "");
    setValue("quality_name", "");
  }, [dependOnKind]);

  useEffect(() => {
    const code = getValues("code");
    if (code) {
      onCodeBlurHandler({ target: { value: code } });
    }
  }, []);

  useEffect(() => {
    if (codeDoesNotExist) {
      setValue("code", codeDoesNotExist);
    }
  }, [codeDoesNotExist]);

  const onCodeBlurHandler = async (e) => {
    if (data && data.dynamic_code) return;
    const code = e.target.value;
    if (code.length !== 13) return;
    try {
      const { brand, size, motif, density, color, quality } =
        await dataProvider.getListNoParams(
          "products/code-detail?code=" + encodeURIComponent(code)
        );
      setValue(
        "name",
        motif.name + " " + density.name + " " + color.name + " " + quality.name
      );
      setValue("brand_name", brand.name);
      setValue("size_name", size.name);
      setValue("motif_name", motif.name);
      setValue("density_name", density.name);
      setValue("color_name", color.name);
      setValue("quality_name", quality.name);
    } catch (error) {}
  };

  let textHelper = undefined;
  let readOnly = false;
  if (dependOnKind) {
    if (data && !data.dynamic_code) {
      textHelper = t("mine.label.13_chars");
      readOnly = true;
    }
  }

  return (
    <>
      <TextInput
        variant="outlined"
        source="code"
        label="mine.label.code"
        fullWidth
        validate={validateCode}
        onBlur={onCodeBlurHandler}
        helperText={textHelper}
      />

      <TextInput
        variant="outlined"
        source="name"
        label="mine.label.name"
        fullWidth
        validate={validateName}
        readOnly={readOnly}
      />
      {readOnly ? (
        <Grid container spacing={0} rowSpacing={0}>
          <Grid item xs={12} md={5.75}>
            <TextInput
              variant="outlined"
              source="brand_name"
              label="mine.label.brand"
              fullWidth
              // validate={validateName}
              // Keep the derived value in the form payload. `disabled` inputs
              // are omitted by react-hook-form, but the API uses these fields
              // to validate that the product code parts match their names.
              readOnly
            />
          </Grid>
          <Grid item xs={0.5} />
          <Grid item xs={12} md={5.75}>
            <TextInput
              variant="outlined"
              source="size_name"
              label="mine.label.size"
              fullWidth
              // validate={validateName}
              readOnly
            />
          </Grid>
          <Grid item xs={12} md={5.75}>
            <TextInput
              variant="outlined"
              source="motif_name"
              label="mine.label.motif"
              fullWidth
              // validate={validateName}
              readOnly
            />
          </Grid>
          <Grid item xs={0.5} />
          <Grid item xs={12} md={5.75}>
            <TextInput
              variant="outlined"
              source="density_name"
              label="mine.label.density"
              fullWidth
              // validate={validateName}
              readOnly
            />
          </Grid>
          <Grid item xs={12} md={5.75}>
            <TextInput
              variant="outlined"
              source="color_name"
              label="mine.label.color"
              fullWidth
              // validate={validateName}
              readOnly
            />
          </Grid>
          <Grid item xs={0.5} />
          <Grid item xs={12} md={5.75}>
            <TextInput
              variant="outlined"
              source="quality_name"
              label="mine.label.quality"
              fullWidth
              // validate={validateName}
              readOnly
            />
          </Grid>
        </Grid>
      ) : null}
    </>
  );
}
